import Axios from "axios";
import Config from "./Config.json";

// Cikkek lekérése
export const getArticles = async (category = null, language = "en") => {
  try {
    const categoryMap = {
      All: 0,
      AITrend: 1,
      Machine_Learning: 2,
      AiTools: 3,
      AIGames: 4,
    };

    let categoryNumber;

    // Ha category szám, akkor használd közvetlenül
    if (typeof category === "number") {
      categoryNumber = category;
    } else if (category && categoryMap[category]) {
      categoryNumber = categoryMap[category];
    } else {
      categoryNumber = 0; // Default: All
    }

    console.log("Küldött adatok", categoryNumber, language);

    let url = `${Config.API_BASE_URL}/articles?category=${categoryNumber}&language=${language}`;
    console.log("Request URL:", url);

    const response = await Axios.get(url);

    if (response.status !== 200) {
      console.error("API hiba: ", response.status, response.statusText);
      return [];
    }

    console.log("Válasz:", response.data);

    if (!response.data) {
      throw new Error("Nincs adat a válaszban.");
    }

    return response.data;
  } catch (error) {
    console.error("Fetching error:", error);
    return [];
  }
};

// Cikk részleteinek lekérése (like és dislike adatokkal együtt)
export const getArticleDetails = async (language = "en") => {
  try {
    const response = await Axios.get(`${Config.API_BASE_URL}/articleDetails`, {
      params: { language },
    });
    return response.data;
  } catch (error) {
    console.error("Hiba a cikk részleteinek lekérésekor:", error);
    throw error;
  }
};

// Első POST kérés
export const postFirstData = async (artID, image, category) => {
  try {
    const response = await Axios.post(
      `${Config.API_BASE_URL}/saveArticleMetadata`,
      {
        artID,
        image,
        category,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Hiba az első POST kérés során:", error);
    throw error;
  }
};

// Második POST kérés
export const postSecondData = async (artID, alt, title, teaser, language) => {
  try {
    const response = await Axios.post(
      `${Config.API_BASE_URL}/saveArticleDetails`,
      {
        artID,
        alt,
        title,
        teaser,
        language,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Hiba a második POST kérés során:", error);
    throw error;
  }
};

// Harmadik POST kérés
export const postThirdData = async (artID, title, markdown, language) => {
  try {
    const response = await Axios.post(
      `${Config.API_BASE_URL}/saveArticleContent`,
      {
        artID,
        title,
        markdown,
        language,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Hiba a harmadik POST kérés során:", error);
    throw error;
  }
};

// Negyedik POST kérés
export const postFourthData = async (artID, language) => {
  try {
    const response = await Axios.post(
      `${Config.API_BASE_URL}/saveLikeContent`,
      {
        artID,
        language,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Hiba a harmadik POST kérés során:", error);
    throw error;
  }
};

// ArtID-k lekérdezése
export const getArticleIds = async () => {
  try {
    const response = await Axios.get(`${Config.API_BASE_URL}/getArticleIds`);
    console.log("Szerver válasz:", response); // <<< EZ KIÍRJA
    return response.data;
  } catch (error) {
    console.error("Hiba az ArtID lekérdezésekor:", error);
    throw error;
  }
};

//Global adatok módosítása
export const updateGlobalData = async (artID, image, category) => {
  try {
    const response = await Axios.post(
      `${Config.API_BASE_URL}/updateGlobalData`,
      {
        artID,
        image,
        category,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Hiba az ArtID lekérdezésekor:", error);
    throw error;
  }
};

// Personal adatok módosítása
export const updatePersonalData = async (
  artID,
  alt,
  title,
  teaser,
  markdown,
  language
) => {
  try {
    const response = await Axios.post(
      `${Config.API_BASE_URL}/updatePersonalData`,
      {
        artID,
        alt,
        title,
        teaser,
        markdown,
        language,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Hiba az ArtID lekérdezésekor:", error);
    throw error;
  }
};
// 👍👎 Like és Dislike küldése az API-n keresztül
// `updateArticleVote` függvény az ügyféloldalon
export const updateArticleVote = async (artId, action, language) => {
  console.log(" Fetching data: ", artId, action, language);
  try {
    const response = await Axios.post(`${Config.API_BASE_URL}/updatelike`, {
      artId,
      action,
      language,
    });

    return response.data;
  } catch (error) {
    console.error("Hiba a like/dislike frissítés során:", error);
    throw error; // Hibát dob, hogy az ügyféloldalon kezelhető legyen
  }
};

// newsletter
export const subscribeToNewsletter = async (email) => {
  try {
    const res = await Axios.post(`${Config.API_BASE_URL}/newsletter`, {
      email,
    });

    return { success: true, message: res.data.message };
  } catch (error) {
    console.error("API hiba:", error.response?.data?.message || error.message);
    return {
      success: false,
      message: error.response?.data?.message || "Hálózati hiba történt.",
    };
  }
};

// Markdown tartalom lekérése
export const getMarkdownContent = async (artID, language = "en") => {
  try {
    const response = await Axios.get(`${Config.API_BASE_URL}/markdown`, {
      params: { artid: artID, lang: language },
    });

    if (response.data && response.data.Content) {
      return response.data.Content;
    } else {
      console.warn("Nincs tartalom a válaszban:", response.data);
      return "";
    }
  } catch (error) {
    console.error("Hiba a markdown lekérésekor:", error);
    return "";
  }
};


// Login
export const login = async (username, password) => {
  try {
    const response = await Axios.post(
      `${Config.API_BASE_URL}/login`,
      { username, password },
      { withCredentials: true }   // 👈 fontos, különben a session cookie nem megy
    );
    return response.data;
  } catch (error) {
    console.error("Login hiba:", error);
    throw error;
  }
};

